import styles from './index.module.css'

import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { uploadProviderFiles } from '@disco/state-management/actions/shortlist-upload-actions'
import { omitHiddenSystemFiles } from '@disco/utils/file-utils'
import { pushUINotification } from '@disco/utils/notifications'

import type { UploadProvider } from 'types/upload'

import { getShortlistBaseRoute } from 'utils/routing'

import UploadOptions from 'components/common/upload/upload-options'
import DocumentHeadTags from 'components/document-head-tags'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'

import { useDispatch } from 'hooks/use-redux'

export default function FileImportPage(): React.ReactNode {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shortlistId: string }>()

  const close = () => {
    const baseRoute = getShortlistBaseRoute(location)
    navigate(baseRoute || '/')
  }

  const title = 'Import files'

  const onFilesSelect = (files: any[], provider: UploadProvider) => {
    dispatch(
      sendMixpanelEvent(`Playlist Creator - Import from ${provider.title}`),
    )
    dispatch(
      uploadProviderFiles(
        provider,
        params.shortlistId!,
        omitHiddenSystemFiles(files),
        pushUINotification,
        {
          context: 'shortlist',
        },
      ),
    )
    close()
  }

  return (
    <DiscoModal
      className="ChannelShare_Modal"
      onRequestClose={close}
      showCloseButton
    >
      <DocumentHeadTags title={`${title} | DISCO`} />
      <Heading size={600}>{title}</Heading>
      <div className={styles.UploadOptions_Wrapper}>
        <UploadOptions onPickedFiles={onFilesSelect} />
      </div>
    </DiscoModal>
  )
}
